import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function Urgency() {
  return;
}